import { render, staticRenderFns } from "./RegistrationNew.vue?vue&type=template&id=4621c642&"
import script from "./RegistrationNew.vue?vue&type=script&lang=ts&"
export * from "./RegistrationNew.vue?vue&type=script&lang=ts&"
import style0 from "./RegistrationNew.vue?vue&type=style&index=0&id=4621c642&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports